import { useMemo } from "react";
import { PACKAGE_ORDER } from "../../constant/constant";
import { PackageResponseData } from "../../features/package/packageResponse";
import { useSelector } from "react-redux";
import { selectCurrentUserRole } from "../../features/auth/authSlice";

interface usePackageListUseMemoProps {
    allPackages: PackageResponseData | undefined;
    search: string;
}

export const usePackageListUseMemo = ({ allPackages, search }: usePackageListUseMemoProps) => {
    
    const sortedPackages = useMemo(() => {
        const all = [
            ...(allPackages?.basic ?? []),
            ...(allPackages?.special ?? []),
            ...(allPackages?.extra ?? []),
        ];

        return all.map((pkg) => ({
            packageID: pkg.packageID,
            packageName: pkg.packageName,
            totalValue: pkg.totalValue,
            quantity: pkg.quantity,
            isActive: pkg.isActive,
            description: pkg.description,
            createdAt: pkg.createdAt,
            updatedAt: pkg.updatedAt,
            packageType: pkg.packageType,
            discountPercentage: pkg.discountPercentage ?? 0,
            canExceed: pkg.canExceed ?? false
        }));
    }, [allPackages]);

    const filteredPackages = useMemo(() => {
        const keyword = search.trim().toLowerCase();

        if (!keyword) return sortedPackages;

        return sortedPackages.filter((pkg) =>
            pkg.packageName.toLowerCase().includes(keyword)
        );
    }, [sortedPackages, search]);

    const userRole = (useSelector(selectCurrentUserRole) ?? '').toLowerCase();
    const isCashier = userRole === 'cashier'
    const groupedPackages = useMemo(() => {
        return filteredPackages.reduce<Record<string, typeof sortedPackages>>(
            (acc, pack) => {
                if (isCashier && !pack.isActive) {
                    return acc;
                }
                const packageName = pack.packageName.toLowerCase();

                let type = "Other";

                if (packageName.includes("basic")) {
                    type = "Basic Package";
                } else if (packageName.includes("special")) {
                    type = "Special Package";
                } else if (packageName.includes("brew classic")) {
                    type = "Brew Classic";
                } else if (packageName.includes("brew signature")) {
                    type = "Brew Signature";
                }

                if (!acc[type]) {
                    acc[type] = [];
                }

                acc[type].push(pack);

                return acc;
            }, {}
        );
    }, [filteredPackages]);

    // const groupedPackages = useMemo(() => {
    //     return filteredPackages.reduce<Record<string, typeof filteredPackages>>(
    //         (acc, pack) => {
    //             const type = pack.packageName.trim().split(/\s+/)[0];

    //             if (!acc[type]) {
    //                 acc[type] = [];
    //             }

    //             acc[type].push(pack);

    //             return acc;
    //         },
    //         {}
    //     );
    // }, [filteredPackages]);

    const orderedGroupedPackages = useMemo(() => {
        return Object.fromEntries(
            Object.entries(groupedPackages).sort(
                ([a], [b]) =>
                    PACKAGE_ORDER.indexOf(a) -
                    PACKAGE_ORDER.indexOf(b)
            )
        );
    }, [groupedPackages]);

    return {
        orderedGroupedPackages,
        filteredPackages
    }
}